import ModalManager from 'global/modal/ModalManager';
import orderHistoryRequestAndDisplayModalModel from './orderHistoryRequestAndDisplayModalModel';

const orderHistoryRequestAndDisplayModal = async (requestObj, modalId) => {
	const response = await makeRequest(requestObj);
	let data;
	try {
		data = handleResponse(response);
	} catch (e) {
		return; // TODO - PSE-5 defensive coding reporting
	}
	displayModal(data, modalId);
};

const makeRequest = requestObj => {
	return orderHistoryRequestAndDisplayModalModel(requestObj);
};

const handleResponse = response => {
	if (response.status === 200) {
		return response.data;
	}
	throw new Error('Add to list error response received');
};

const displayModal = (data, modalId) => {
	const modalManager = new ModalManager();
	modalManager.insertResponse(data, modalId);
};

export {
	orderHistoryRequestAndDisplayModal as default,
	handleResponse,
	makeRequest,
	displayModal,
};
